import type { TrackEventHandler } from "@sg-protect/shell";
import { anchorAuxClickHandler, anchorClickHandler } from "./anchorClickedHandler.ts";
import { buttonClickHandler } from "./buttonClickedHandler.ts";
import { checkboxChangeHandler, hopperCheckboxClickHandler } from "./checkboxChangedHandler.ts";
import { DOMEventTracker } from "./domEventTracker.ts";
import { dropdownItemClickHandler } from "./dropdownItemClickHandler.ts";
import { menuItemClickHandler } from "./menuItemClickHandler.ts";
import { hopperRadioChangeHandler, radioChangeHandler } from "./radioChangedHandler.ts";

const changeTracker = new DOMEventTracker("change");
changeTracker.addHandler(checkboxChangeHandler);
changeTracker.addHandler(radioChangeHandler);

const clickTracker = new DOMEventTracker("click");
clickTracker.addHandler(buttonClickHandler);
clickTracker.addHandler(anchorClickHandler);
clickTracker.addHandler(menuItemClickHandler);
clickTracker.addHandler(dropdownItemClickHandler);
clickTracker.addHandler(hopperCheckboxClickHandler);
clickTracker.addHandler(hopperRadioChangeHandler);

const auxClickTracker = new DOMEventTracker("auxclick");
auxClickTracker.addHandler(anchorAuxClickHandler);

export function initDomEventTracker(trackEvent: TrackEventHandler) {
    changeTracker.init(trackEvent);
    clickTracker.init(trackEvent);
    auxClickTracker.init(trackEvent);
}

export function removeDomEventTracker() {
    changeTracker.remove();
    clickTracker.remove();
    auxClickTracker.remove();
}
